<script>
import SearchSection from "./searchSection.vue";
import {mapActions} from "vuex";

export default {
  name: "topImageSection",
  data() {
    return {
      bannerImages: [
        require('../../assets/main-banner.png')
      ],
      currentImageIndex: 0,
    };
  },
  computed: {
    currentBannerImage() {
      console.log("startImageRotation", this.currentImageIndex);
      return this.bannerImages[this.currentImageIndex];
    },
  },
  mounted() {
    // this.getAllHomeBannerImages();
    this.startImageRotation();
  },
  methods: {
    ...mapActions('common', ['getAllHomeBannerImageList']),
    getAllHomeBannerImages() {
      this.getAllHomeBannerImageList({ params: {}, callback: this.callbackGetAllHomeBannerImageList });
    },
    callbackGetAllHomeBannerImageList(res) {
      console.log("callbackGetAllHomeBannerImageList", res);
      if (res.code === 0 ) {

        console.log(res.data);
        this.bannerImages = res.data;
      }
    },
    startImageRotation() {
      setInterval(() => {

        this.currentImageIndex =
          (this.currentImageIndex + 1) % this.bannerImages.length;
      }, 15000); // Change image every 5 seconds

    },
  },
  created() {
    console.log("banner started");
    this.getAllHomeBannerImages();
  },
  components: { SearchSection }
};
</script>

<template>
  <el-row>
    <el-col :span="24">
      <div class="banner-container">
        <img
          class="banner-image"
          loading="lazy"
          :src="currentBannerImage"
          style="opacity: 0.5"
          alt="banner"
        />
        <div class="banner-text-container">
          <search-section :is-home-page=true />
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<style scoped>
.banner-container {
  flex-direction: column;
  overflow: hidden;
  align-self: center;
  position: relative;
  display: flex;
  height: 300px;
  /* justify-content: center;
  align-items: center; */
  padding: 10px 1fr;
}

.banner-image {
  position: absolute;
  inset: 0;
  height: 100%;
  width: 100%;
  opacity: 0.7;
  object-fit: cover;
  object-position: center;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.banner-text-container {
  position: relative;
  display: flex;
  flex-direction: column;
  //align-items: center;
  margin: 5% 0 3px;
}

.banner-heading {
  color: #fff;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.15);
  text-transform: uppercase;
  font: 700 25px Metropolis, sans-serif;
}

.banner-subheading {
  color: #fff;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.15);
  text-transform: uppercase;
  align-self: stretch;
  margin-top: 160px;
  padding-bottom: 20px;
  font: 700 37px Metropolis, sans-serif;
}

@media only screen and (max-width: 375px) {
  .banner-subheading {
    margin-top: 100px;
    padding-bottom: 10px;
    font: 700 25px Metropolis, sans-serif;
    color: #fff;
    text-align: center;
    font-feature-settings: "clig" off, "liga" off;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.15);
    text-transform: uppercase;
    align-self: stretch;
  }

  .banner-container {
    height: 340px;
    flex-direction: column;
    overflow: hidden;
    align-self: center;
    position: relative;
    display: flex;
    padding: 10px 1fr;
  }

  .banner-heading {
    font: 700 18px Metropolis, sans-serif;
    color: #fff;
    text-align: center;
    font-feature-settings: "clig" off, "liga" off;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.15);
    text-transform: uppercase;
  }
}

@media only screen and (min-width: 600px) and (max-width: 1300px) {
  .banner-subheading {
    margin-top: 100px;
    padding-bottom: 10px;
    font: 700 47px Metropolis, sans-serif;
    color: #fff;
    text-align: center;
    font-feature-settings: "clig" off, "liga" off;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.15);
    text-transform: uppercase;
    align-self: stretch;
  }

  .banner-container {
    height: 400px;
    flex-direction: column;
    overflow: hidden;
    align-self: center;
    position: relative;
    display: flex;
    padding: 10px 1fr;
  }

  .banner-heading {
    font: 700 35px Metropolis, sans-serif;
    color: #fff;
    text-align: center;
    font-feature-settings: "clig" off, "liga" off;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.15);
    text-transform: uppercase;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/package/topImageSection.vue